import {Injectable} from '@angular/core';
import {EventRepository} from './event-repository';

@Injectable()
export class EventTestFacade {
    constructor(private eventRepository: EventRepository) { }

    listPartners() {
        return this.eventRepository.listPartners();
    }

    listServices() {
        return this.eventRepository.listActivities();
    }

    listEvents(activityId = null) {
        return this.eventRepository.listEvents(activityId);
    }

    listApplications() {
        return this.eventRepository.listApplications();
    }
}
